module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "btn-group version-manage-dropdown-btn",
    attrs: {
      "id": "version-list-popmenu"
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle version-manage-dropdown",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.currentVersion.versionname))]), _vm._v(" "), _c('span', {
    staticClass: "caret pull-right version-manage-dropdown-icon"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu version-manage-dropdown",
    attrs: {
      "id": "version-list-pop-menu"
    }
  }, [_c('li', {
    attrs: {
      "data-target": "#modal-new-version"
    },
    on: {
      "click": _vm.toNewVersion
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _vm._l((_vm.versionList), function(item, index) {
    return _c('li', {
      key: item.id
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.selectVersoin(index)
        }
      }
    }, [_vm._v(_vm._s(item.versionname))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "version-manage-dropdown-more",
    on: {
      "click": function($event) {
        _vm.toLoadMoreVersion(_vm.currentVersoinPage)
      }
    }
  }, [_vm._v("\n            More   \n            "), _c('i', {
    staticClass: "fa fa-angle-double-right"
  })])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.versionList.length > 0),
      expression: "versionList.length>0"
    }],
    staticClass: "version-manage-content"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.currentVersion.GeneralSetting.StageSupport), function(item) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12 version-manage-stage-margin"
    }, [_c('div', {
      class: _vm.getStageClassByTypeId(item)
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('span', {
      staticClass: "box-title"
    }, [_vm._v(_vm._s(_vm.getNameByTypeId(item)))]), _vm._v(" "), _c('span', {
      class: _vm.getStageLogClassByTypeId(item),
      on: {
        "click": function($event) {
          _vm.toShowLog(item)
        }
      }
    }, [_vm._v("Log")])]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('div', {
      staticClass: "btn-group version-manage-box-body-dropdown"
    }, [(item !== 'S3') ? _c('div', [_c('button', {
      staticClass: "btn btn-default dropdown-toggle version-manage-dropdown version-manage-box-body-dropdown-btn",
      attrs: {
        "type": "button",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }
    }, [(_vm.currentStageBuild[item].buildnumber) ? _c('span', {
      staticClass: "pull-left"
    }, [_vm._v("build " + _vm._s(_vm.currentStageBuild[item].buildnumber) + " (" + _vm._s(_vm._f("formatDate")(_vm.currentStageBuild[item].time / 1000000)) + ")")]) : _c('span', {
      staticClass: "pull-left"
    }, [_vm._v("-")]), _vm._v(" "), _c('span', {
      staticClass: "caret pull-right version-manage-dropdown-icon"
    })]), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu version-manage-dropdown version-manage-box-body-dropdown-btn"
    }, [_c('li', {
      attrs: {
        "data-target": "#modal-new-version"
      },
      on: {
        "click": function($event) {
          _vm.toNewBuild(item)
        }
      }
    }, [_vm._m(1, true)]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHasBuildList(item)),
        expression: "isHasBuildList(item)"
      }],
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }), _vm._v(" "), _vm._l((_vm.getBuildlistById(item)), function(b, index) {
      return _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.selectBuild(item, index)
          }
        }
      }, [_vm._v("build " + _vm._s(b.buildnumber) + " (" + _vm._s(_vm._f("formatDate")(b.time / 1000000)) + ")")])])
    }), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHasBuildList(item)),
        expression: "isHasBuildList(item)"
      }],
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }), _vm._v(" "), _c('li', [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHasBuildList(item)),
        expression: "isHasBuildList(item)"
      }],
      staticClass: "version-manage-dropdown-more",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.toLoadMoreBuild(item)
        }
      }
    }, [_vm._v("\n                        More   \n                        "), _c('i', {
      staticClass: "fa fa-angle-double-right"
    })])])], 2)]) : _c('div', [_c('button', {
      staticClass: "btn btn-default dropdown-toggle version-manage-dropdown version-manage-box-body-dropdown-btn",
      attrs: {
        "type": "button"
      }
    }, [(_vm.currentStageBuild[item].buildnumber) ? _c('span', {
      staticClass: "pull-left"
    }, [_vm._v("build " + _vm._s(_vm.currentStageBuild[item].buildnumber) + " (" + _vm._s(_vm._f("formatDate")(_vm.currentStageBuild[item].time / 1000000)) + ")")]) : _c('span', {
      staticClass: "pull-left"
    }, [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
      staticClass: "version-manage-comment"
    }, [_c('div', {
      class: _vm.currentStageBuild[item].result === 1 ? 'version-manage-build-state gone' : 'version-manage-build-state'
    }, [_c('p', [_c('i', {
      class: _vm.getBuildStageClassByTypeId(_vm.currentStageBuild[item].result)
    }), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.getState(_vm.currentStageBuild[item].result)) + "\n                  ")])]), _vm._v(" "), _c('p', {
      class: _vm.emptyToInVisibiliy(_vm.currentStageBuild[item].comment, 'version-manage-stage-comment')
    }, [_vm._v(_vm._s(_vm.currentStageBuild[item].comment))])]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "version-manage-button"
    }, [(item !== 'S3') ? _c('div', {
      staticClass: "version-manage-button"
    }, [_c('button', {
      class: _vm.emptyToInVisibiliy(_vm.currentBuildList[item].length > 0, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toShowShell(item)
        }
      }
    }, [_vm._v("查看SHELL配置")]), _vm._v(" "), _c('button', {
      class: _vm.emptyToInVisibiliy(_vm.currentBuildList[item].length > 0, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toShowDownload(item)
        }
      }
    }, [_vm._v("Download App")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.currentBuildList[item].length > 0 ?
            _vm.toSendDingDing(item) : _vm.toNewBuild(item)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.currentBuildList[item].length > 0 ?
      '发送钉钉通知' : 'New Build') + "\n                  ")])]) : _c('div', {
      staticClass: "version-manage-button"
    }, [_c('button', {
      class: _vm.isPublishSelectSuccess(item, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toShowShell(item)
        }
      }
    }, [_vm._v("查看SHELL配置")]), _vm._v(" "), _c('button', {
      class: _vm.isPublishSelectSuccess(item, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toDoPublishClick(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.getBtnText(item)))]), _vm._v(" "), _c('button', {
      class: _vm.isPublishSelectSuccess(item, 'btn btn-info'),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toSendDingDing(item)
        }
      }
    }, [_vm._v("发送钉钉通知")])])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "version-manage-log"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-file-code-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "version-manage-log-title"
  }, [_vm._v("Develop Log")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pull-right btn-device-user-list-setting",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSaveLog
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('textarea', {
    staticClass: "form-control version-manage-log-textarea",
    attrs: {
      "id": "currentVersionDevelopLog",
      "placeholder": "Develop log..."
    },
    domProps: {
      "value": _vm.currentVersion.developlog
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-file-powerpoint-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "version-manage-log-title"
  }, [_vm._v("Publish Log")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pull-right btn-device-user-list-setting",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSaveLog
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('textarea', {
    staticClass: "form-control version-manage-log-textarea",
    attrs: {
      "id": "currentVersionReleaseLog",
      "placeholder": "Publish log..."
    },
    domProps: {
      "value": _vm.currentVersion.releaselog
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.versionList.length <= 0),
      expression: "versionList.length<=0"
    }]
  }, [_c('p', {
    staticClass: "large_title"
  }, [_vm._v("There's no version!")]), _vm._v(" "), _c('div', {
    staticClass: "version-manage-new-version"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toNewVersion
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("   New Version\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-new-version"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Version Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newversion_name),
      expression: "newversion_name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "version number"
    },
    domProps: {
      "value": (_vm.newversion_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newversion_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Develop log")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newversion_developlog),
      expression: "newversion_developlog"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "Develop log..."
    },
    domProps: {
      "value": (_vm.newversion_developlog)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newversion_developlog = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row modal-new-version-shell"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box modal-new-version-shell-box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("TEST")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newversion_developshell),
      expression: "newversion_developshell"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "shell..."
    },
    domProps: {
      "value": (_vm.newversion_developshell)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newversion_developshell = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("API")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newversion_releaseshell),
      expression: "newversion_releaseshell"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "shell..."
    },
    domProps: {
      "value": (_vm.newversion_releaseshell)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newversion_releaseshell = $event.target.value
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("New Version")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu alert-del pull-right"
  }, [_vm._m(5), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-default pull-left"
  }, [_vm._v("Not Sure")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger pull-right",
    on: {
      "click": _vm.toDoNewVersion
    }
  }, [_vm._v("Confirm")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-new-build"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.macRobotList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-1 col-sm-2 col-xs-2 modal-dialog-sendto-robotpick"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newbuild_robotid),
        expression: "newbuild_robotid"
      }],
      staticClass: "modal-dialog-sendto-robotpick-input",
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.newbuild_robotid, item.id)
      },
      on: {
        "change": function($event) {
          _vm.newbuild_robotid = item.id
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-2 col-sm-3 col-xs-3"
    }, [(!item.icon) ? _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": require("../../../static/img/img_app_list_icon_default.png")
      }
    }) : _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": 'https://d.din.bz/' + item.icon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-9 col-md-9 col-sm-7 col-xs-7 device-user-list-data"
    }, [_c('p', {
      staticClass: "device-user-list-username"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-3 col-sm-3 col-xs-4"
    }, [(item.isOnline == false) ? _c('span', {
      staticClass: "robot-list-status label label-default"
    }, [_vm._v("offline")]) : (item.task == 0) ? _c('span', {
      staticClass: "robot-list-status label label-info"
    }, [_vm._v("free")]) : (item.task > 0) ? _c('span', {
      staticClass: "robot-list-status label label-warning"
    }, [_vm._v("building")]) : _vm._e()])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newbuild_developlog),
      expression: "newbuild_developlog"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "Comment..."
    },
    domProps: {
      "value": (_vm.newbuild_developlog)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newbuild_developlog = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row modal-new-version-shell"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box modal-new-version-shell-box"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Shell")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newbuild_developshell),
      expression: "newbuild_developshell"
    }],
    staticClass: "form-control edit-information-textarea",
    attrs: {
      "placeholder": "shell..."
    },
    domProps: {
      "value": (_vm.newbuild_developshell)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newbuild_developshell = $event.target.value
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Cancel"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoNewBuild
    }
  }, [_vm._v("New Build")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-shell"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "modal-dialog-shell-p"
  }, [_vm._v(_vm._s(_vm.shellDialogContent))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-download"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(9), _vm._v(" "), (_vm.downloadLink) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('qrcode', {
    staticStyle: {
      "margin-left": "31%"
    },
    attrs: {
      "value": _vm.downloadLink,
      "options": {
        width: 200
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "modal-dialog-shell-p add-agent-choose"
  }, [_c('a', {
    on: {
      "click": _vm.toDownloadLink
    }
  }, [_vm._v(_vm._s(_vm.downloadLink))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-log"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "modal-dialog-shell-p"
  }, [_vm._v(_vm._s(_vm.logDialogCurrentContent))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "version-manage-dropdown-new",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("New Version\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "version-manage-dropdown-new",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("New Build\n                      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "version-manage-stage-more invisibiliy"
  }, [_vm._v("\n                more   \n                "), _c('i', {
    staticClass: "fa fa-angle-double-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("New Version")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Shell Configuration")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_c('i', {
    staticClass: "icon fa fa-warning alert-del-warning"
  }), _vm._v("\n                Please confirm that the datas below in\n                "), _c('strong', [_vm._v("Shell Configuration")]), _vm._v(" are filled in correctly :\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "security-state-dialog-status modal-dialog-new-version-confirm"
  }, [_vm._v("development branch")]), _vm._v(" "), _c('p', {
    staticClass: "security-state-dialog-status"
  }, [_vm._v("Application id")]), _vm._v(" "), _c('p', {
    staticClass: "security-state-dialog-status modal-dialog-new-version-confirm-down"
  }, [_vm._v("jPush key")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("New Build")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Shell Configuration")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Shell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Download App")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("RealTime LogCat")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d3e1cd3a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3e1cd3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Android.vue
// module id = 497
// module chunks = 1